module.exports = require('./src/normalizeWheel.js');



/*****************
 ** WEBPACK FOOTER
 ** /Users/prosciutto/Works/Slam/~/normalize-wheel/index.js
 ** module id = 541
 ** module chunks = 0
 **/